import { schema } from 'normalizr'

export default [
    new schema.Entity('cancellations', {}, { idAttribute: 'premium_cancel_request_id' }),
]
